import { Injectable, signal } from '@angular/core';

@Injectable()
export class CtaDialogStore {
  public static readonly expandedErrorDeliverablePanelId = signal<string | null>(null);
  public static readonly expandedErrorExecutionPanelId = signal<string | null>(null);
  public static readonly ctaExecutionExpandedIdMap = signal<Map<string, string | null>>(new Map());
  public readonly expandedCtaPanelId = signal<string | null>(null);

  public static setExpandedErrorDeliverablePanel(id: string | null): void {
    this.expandedErrorDeliverablePanelId.set(id);
  }

  public static setExpandedErrorExecutionPanel(id: string | null): void {
    this.expandedErrorExecutionPanelId.set(id);
  }

  public static setCtaExecutionExpandedId(ctaId: string, executionId: string | null): void {
    this.ctaExecutionExpandedIdMap.update((map) => {
      const newMap = new Map(map);
      newMap.set(ctaId, executionId);

      return newMap;
    });
  }

  public static clearCtaExecutionExpandedIdMap(): void {
    this.ctaExecutionExpandedIdMap.set(new Map());
  }

  public setExpandedCtaPanel(id: string | null): void {
    this.expandedCtaPanelId.set(id);
  }
}
